export default class UserInvitationDto {

    constructor(email: string | null, roleGroupId: number | null = null) {
        this.Email = email;
        this.RoleGroupId = roleGroupId;
    }

    Email: string | null;
    RoleGroupId: number | null;
}